import { render, staticRenderFns } from "./select.vue?vue&type=template&id=812d6f04&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('812d6f04')) {
      api.createRecord('812d6f04', component.options)
    } else {
      api.reload('812d6f04', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=812d6f04&", function () {
      api.rerender('812d6f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/select.vue"
export default component.exports